<template>
  <div class="courseware-list" v-show="coursewareList.length">
    <el-popover
      v-model="visible"
      placement="top-start"
      trigger="click"
      popper-class="courseware-popover"
      :visible-arrow="false"
      :append-to-body="true"
    >
      <div
        class="courseware-button"
        slot="reference"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <div class="button-content">
          <img class="file-icon" :src="fileTypeIcon" alt="" />
          <div class="count-badge" v-if="coursewareList.length > 0">
            {{ coursewareList.length }}
          </div>
        </div>
      </div>

      <div class="courseware-popover-content">
        <div class="courseware-items">
          <div
            v-for="item in coursewareList"
            :key="item.id"
            class="courseware-item"
            @click="handleSwitchFile(item)"
          >
            <div class="item-icon">
              <img class="file-icon" :src="getFileIcon(item)" alt="" />
            </div>
            <div class="item-content">
              <div class="item-name" :title="item.doc_name">
                {{ item.doc_name }}
              </div>
            </div>
            <div class="item-actions">
              <el-button
                type="text"
                class="delete-btn"
                @click.stop="handleDelete(item)"
              >
                <img src="@saas/pages/assets/images/live/delete.png" alt="" />
              </el-button>
            </div>
          </div>
        </div>

        <div
          class="upload-section"
          @click="handleUpload"
          v-if="coursewareList.length < maxListLength"
        >
          <img src="@saas/pages/assets/images/live/upload.png" alt="" />
          <span>
            上传课件（{{ coursewareList.length }}/{{ maxListLength }}）
          </span>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { fileImagebyFileName, isImage, isVideo, isDoc } from "@saas/components";
import { mapMutations, mapState } from "vuex";
import { deleteRoomFile } from "@saas/service-api/src/courseware";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  name: "CoursewareList",
  data() {
    return {
      visible: false,
      isHovered: false,
      currentCourseware: null,
    };
  },
  watch: {
    whiteBoardService: {
      handler(val) {
        if (val) {
          this.whiteBoardService.on("tabSwitchFile", this.onTabSwitchFile);
          this.currentCourseware = this.whiteBoardService.getFileInfo();
          console.log("currentCourseware____", this.currentCourseware);
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.whiteBoardService.off("tabSwitchFile", this.onTabSwitchFile);
  },
  computed: {
    ...mapState("live", [
      "roomInfo",
      "whiteBoardService",
      "imService",
      "remoteScreenShareInfo",
    ]),
    fileTypeIcon() {
      const name = this.currentCourseware?.title || " ";
      return fileImagebyFileName(name);
    },
    maxListLength: () => 10,
    coursewareList() {
      return this.roomInfo.doc || [];
    },
    // 是否在接收共享（）
    isScreenShareRemote() {
      return ["start", "pause"].includes(this.remoteScreenShareInfo.status);
    },
  },
  methods: {
    ...mapMutations("live", [
      "setShowUploadCourseware",
      "setRoomInfo",
      "setWhiteboardType",
    ]),
    onTabSwitchFile(fid) {
      console.log("tabSwitchFile____", fid);
      this.currentCourseware = this.whiteBoardService.getFileInfo();
      console.log("currentCourseware____tabSwitchFile", this.currentCourseware);
    },
    handleMouseEnter() {
      this.isHovered = true;
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
    handleDelete(file) {
      uploadLiveLog({
        message: "用户删除课件",
        extra: {
          component: "CoursewareList",
          action: "click_courseware_delete",
          fileId: file.id,
          fileName: file.doc_name,
        },
      });

      deleteRoomFile({
        room_id: this.roomInfo.id,
        doc_id: file.id,
      }).then((res) => {
        if (res.code === 1) {
          this.$darkMessage.success("删除成功");
          //获取当前展示的课件id
          const currentRoomFileId = this.whiteBoardService.getCurrentFile();
          const list = this.coursewareList.filter(
            (item) => item.id !== file.id
          );
          this.whiteBoardService.deleteFile(file.roomFileId);
          if (file.roomFileId === currentRoomFileId) {
            // 白板插入的是这个课件， 删除后需要展示第一个课件,如果没有课件了，切换到白板
            if (list.length === 0) {
              this.handleUpdateWhiteboardType("whiteboard");
            } else {
              const firstId = list[0].roomFileId;
              this.whiteBoardService.switchFile(firstId);
            }
          }
          if (list.length === 0) {
            this.handleUpdateWhiteboardType("whiteboard");
          }
          this.setRoomInfo({
            doc: list,
          });
          this.handleUpdateCoursewareInfo();
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },
    handleUpdateWhiteboardType(type) {
      this.setWhiteboardType(type);
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "whiteboardType",
          data: {
            type: type,
          },
        },
      });
    },
    handleUpdateCoursewareInfo() {
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "coursewareUpdate",
        },
      });
    },
    handleUpload() {
      uploadLiveLog({
        message: "用户上传课件",
        extra: {
          component: "CoursewareList",
          action: "click_courseware_upload",
        },
      });

      this.setShowUploadCourseware(true);
    },
    getFileIcon(file) {
      return fileImagebyFileName(file.doc_name);
    },
    handleSwitchFile(file) {
      uploadLiveLog({
        message: "用户切换课件",
        extra: {
          component: "CoursewareList",
          action: "click_courseware_switch",
          fileId: file.id,
          fileName: file.doc_name,
          pages: file.pages,
        },
      });
      if (!file.pages && isDoc(file.doc_name)) {
        this.$darkMessage.error("不能插入页数为0的课件");
        return;
      }
      if (isVideo(file.doc_name)) {
        const id = this.whiteBoardService.addVideoFile({
          url: file.transcode_result,
          title: file.doc_name,
        });
        file.fileId = id;
        this.whiteBoardService.switchFile(id);
      } else if (isImage(file.doc_name)) {
        const id = this.whiteBoardService.addImagesFile({
          urls: [file.transcode_result],
          title: file.doc_name,
        });
        file.fileId = id;
        this.whiteBoardService.switchFile(id);
      } else {
        const config = {
          url: file.transcode_result,
          title: file.doc_name,
          pages: file.pages,
          resolution: file.resolution,
        };
        const id = this.whiteBoardService.addTranscodeFile(config);
        file.fileId = id;
        this.whiteBoardService.switchFile(id);
      }

      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.courseware-list {
  position: relative;

  .courseware-button {
    width: 46px;
    height: 46px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
    border-radius: 99px;
    border: 1px solid #e5e6eb;
    cursor: pointer;
    transition: background-color 0.3s ease;
    position: relative;

    &:hover {
      background-color: #c9cdd4;
    }

    .button-content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      .file-icon {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .count-badge {
        position: absolute;
        width: 25px;
        height: 20px;
        background: #e5e6eb;
        border-radius: 100px 100px 100px 100px;
        border: 2px solid #ffffff;
        top: -6px;
        right: -6px;
        border-radius: 8px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        font-weight: 500;
        font-size: 12px;
        color: #1d2129;
      }
    }
  }
}

.courseware-popover-content {
  width: 228px;
  .courseware-items {
    background: #27272a;
    border-radius: 12px;
    overflow: auto;
    max-height: 250px;
    overflow: auto;
    // 自定义滚动条样式
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #e5e6e8;
      border-radius: 2px;

      &:hover {
        background: #c9cdd4;
      }
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
    .courseware-item {
      display: flex;
      align-items: center;
      padding: 8px 16px;
      gap: 8px;
      background: #27272a;
      border-bottom: 1px solid #303031;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
      .item-icon {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .item-content {
        flex: 1;
        min-width: 0;

        .item-name {
          color: #ecedee;
          font-size: 12px;
          font-weight: 500;
          line-height: 2em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .item-actions {
        flex-shrink: 0;

        .delete-btn {
          padding: 0;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #86909c;

          &:hover {
            color: #ff4757;
          }
        }
      }
    }
  }

  .upload-section {
    padding: 8px 16px;
    background: #27272a;
    border-radius: 12px;
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ecedee;
    font-size: 12px;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
}
</style>
<style>
.courseware-popover {
  background: unset;
  box-shadow: unset;
  border: none;
  padding: 0;
}
</style>
